import {
  CREATE_ACTION,
  UPDATE_ACTION,
  DELETE_ACTION,
  MANAGE_ACTION,
  CONTRACT_RESOURCE,
  CONTRACT_CLOSING_EXCEPTION,
  PAYMENT_IMPORT,
} from '@/constants/resources'
import {
  isLockedStatus,
  isStatusOnlyEdit,
  lockTooltip,
  serverAllowsDelete,
  serverAllowsEdit,
  serverAllowsExtraordinary,
} from '@/modules/contract/utils/contractLock'

// Permissões de contrato reunidas em um só lugar.
//
// Os `can*` são apenas CASL (valem para a tela inteira). Os `may*` recebem a linha/o
// contrato e combinam a permissão com o bloqueio do fechamento mensal devolvido pelo
// servidor. Só "Editar" e "Excluir" passam por esse bloqueio; as demais ações do contrato
// ficam sempre liberadas. Com a competência fechada, "Editar" ainda pode vir liberado só
// para trocar entre status válidos (`edit_mode = status_only`); "Excluir" não. Itens bloqueados continuam visíveis e desabilitados, com o
// motivo em `contractLockTooltip` — o usuário precisa entender por que não pode agir.
export const contractPermissions = {
  computed: {
    canCreateContract() {
      return this.$can(CREATE_ACTION, CONTRACT_RESOURCE)
    },
    canUpdateContract() {
      return this.$can(UPDATE_ACTION, CONTRACT_RESOURCE)
    },
    canDeleteContract() {
      return this.$can(DELETE_ACTION, CONTRACT_RESOURCE)
    },
    canImportPayments() {
      return this.$can(CREATE_ACTION, PAYMENT_IMPORT)
    },
    canUpdateImportedPayments() {
      return this.$can(UPDATE_ACTION, PAYMENT_IMPORT)
    },
  },
  methods: {
    // Founder (53) e Suporte (28) recebem `contract_closing_exception:manage`.
    canManageClosingException() {
      return this.$can(MANAGE_ACTION, CONTRACT_CLOSING_EXCEPTION)
    },
    // Contrato mutável: fora dos status terminais e liberado pelo servidor.
    contractIsMutable(contract) {
      return !isLockedStatus(contract) && serverAllowsEdit(contract)
    },
    mayEdit(contract) {
      return this.canUpdateContract && this.contractIsMutable(contract)
    },
    // Campos customizados (ex.: "Prêmio mensal") só na edição completa: a rota não passa pelo
    // guard do fechamento, então o modo `status_only` não pode liberá-los.
    mayEditFields(contract) {
      return this.mayEdit(contract) && !isStatusOnlyEdit(contract)
    },
    mayDelete(contract) {
      return this.canDeleteContract && !isLockedStatus(contract) && serverAllowsDelete(contract)
    },
    mayChangeExtraordinarily(contract) {
      return this.canManageClosingException() && serverAllowsExtraordinary(contract)
    },
    contractLockTooltip(contract) {
      return lockTooltip(contract)
    },
    contractDeleteLockTooltip(contract) {
      return lockTooltip(contract, 'delete')
    },
  },
}

export default contractPermissions
